import { render, staticRenderFns } from "./bindphone.vue?vue&type=template&id=c0339f5c&scoped=true"
import script from "./bindphone.vue?vue&type=script&lang=ts"
export * from "./bindphone.vue?vue&type=script&lang=ts"
import style0 from "./bindphone.vue?vue&type=style&index=0&id=c0339f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0339f5c",
  null
  
)

export default component.exports